import React, { useMemo } from 'react';
import {
  AssignmentOutlined,
  CalendarMonthOutlined,
  FactCheckOutlined,
  GavelOutlined,
  HelpOutlineOutlined,
  LocalHospitalOutlined,
  MenuBookOutlined,
  PaymentsOutlined,
  PeopleOutlined,
  RocketLaunchOutlined,
  SchoolOutlined,
  SettingsOutlined,
  VideoCallOutlined,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { supportCategoryRoute } from '@uplift/constants';
import { HelpCenterTile, HelpfulLinksSection } from '@uplift/pages';
import { getSupportArticlesByCategory, SupportArticleCategory } from './articles';

const CATEGORY_ICONS: Record<SupportArticleCategory, React.ComponentType<SvgIconProps>> = {
  'getting-started': RocketLaunchOutlined,
  'onboarding': SchoolOutlined,
  'sessions': VideoCallOutlined,
  'calendar': CalendarMonthOutlined,
  'matching': PeopleOutlined,
  'payments': PaymentsOutlined,
  'technical': SettingsOutlined,
  'documentation': AssignmentOutlined,
  'assessments': FactCheckOutlined,
  'psychiatry': LocalHospitalOutlined,
  'reference': MenuBookOutlined,
  'policies': GavelOutlined,
  'general': HelpOutlineOutlined,
};

export const SupportArticleIndex: React.FC = () => {
  const tiles = useMemo((): HelpCenterTile[] => (
    getSupportArticlesByCategory().map(group => ({
      title: group.label,
      description: group.description,
      icon: CATEGORY_ICONS[group.category],
      href: supportCategoryRoute.createLink({ category: group.category }),
    }))
  ), []);

  return (
    <HelpfulLinksSection
      heading="Browse by topic"
      tiles={tiles}
    />
  );
};
